/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ReportHistoryProvider } from 'src/app/providers';
import { LogService } from 'src/app/services';


@Component({
  selector: 'report-history-modal',
  templateUrl: './report-hostory.modal.html',
  styleUrls: ['./report-history.modal.scss']
})
export class ReportHistoryModal implements OnInit, OnDestroy, AfterViewInit {
  subscription: any;
  reportId: string;
  historyId: string;
  isLoading: boolean;
  historyDetails = [];
  totalItems: number = 0;
  currentPage: number = 1;
  dataLoaded: boolean = false;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public reportHistoryProvider: ReportHistoryProvider,
    private logService : LogService,
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngAfterViewInit(): void {
    setTimeout(()=>{
      this.loadHistoryDetails(this.reportId, this.historyId, this.currentPage);
    },1000)
  }


  loadHistoryDetails(reportId: string, historyId: string, page: number):void{
      this.isLoading = true;
      this.reportHistoryProvider.getHistoryDetails(reportId, historyId, page)
        .subscribe(
          data => {
            this.isLoading = false;
            if (data.success) {
              if(data.result) {
                this.historyDetails = JSON.parse(data.result);
                this.totalItems = data.result?.totalItems;
                this.currentPage = page;
              }
            }
            this.dataLoaded = true;
          }, err => {
            this.isLoading = false;
            this.logService.error(err);
          });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onCancel(): void {
    this.bsModalRef.hide();
  }

  pageChanged(event: any): void {
    if (event.page != this.currentPage)
       this.loadHistoryDetails(this.reportId, this.historyId, this.currentPage);
  }
}
